<ul class="lang-switcher">
    <li *ngFor="let lang of translateService.getLangs()" [class.active]="translateService.currentLang === lang">
        <a (click)="setLanguage(lang)">{{ lang | uppercase }}</a>
    </li>
</ul>
